interface CoordinatesData {
  id?: string;
  docId?: string;
  value?: string;
  pageId?: string;
  pageIndex?: number;
  x0?: number;
  x1?: number;
  y0?: number;
  y1?: number;
}

export default class Coordinates implements CoordinatesData {
  xRatio: number = 1;
  yRatio: number = 1;
  id: string = "";
  docId: string = "";
  value: string = "";
  pageId: string = "PG0";
  /**
   * Page Index
   */
  pageIndex: number = 0;
  x0: number = 0;
  x1: number = 0;
  y0: number = 0;
  y1: number = 0;

  get x(): number {
    return this.x0 * this.xRatio;
  }
  get y(): number {
    return this.y0 * this.yRatio;
  }
  get width(): number {
    return this.x1 * this.xRatio - this.x;
  }
  get height(): number {
    return this.y1 * this.yRatio - this.y;
  }

  constructor(data?: CoordinatesData) {
    if (data) this.extend(data);
  }

  extend(data: CoordinatesData) {
    Object.assign(this, data);
  }

  static construct(
    x0: number,
    x1: number,
    y0: number,
    y1: number,
    page?: string,
  ) {
    const coordinate = new Coordinates();
    coordinate.x0 = x0;
    coordinate.x1 = x1;
    coordinate.y0 = y0;
    coordinate.y1 = y1;
    if (page != null) coordinate.pageId = page;

    return coordinate;
  }
}
export { CoordinatesData as CoordinateData };
